import React from 'react';
import { useDispatch } from 'react-redux';
import { showOrgManageRolesModal } from '../actions/modal.js';
import { resendInvitionToOrganisationalUnit, cancelInvitionToOrganisationalUnit } from '../actions/organisation';
import { ContextualMenu, forceCloseContextualMenu } from '../components/shared/contextualMenu/content';

function OrganisationalUnitUserActionsMenu(props) {
  const dispatch = useDispatch();

  const clickManageRoles = (userId) => {
    dispatch(showOrgManageRolesModal(true));
  };

  const resendInvitation = (user) => {
    dispatch(resendInvitionToOrganisationalUnit(props.organisationalUnit, user));

    setTimeout(() => {
      forceCloseContextualMenu('.manage-users-organisational-unit-container');
    }, 100);
  };

  const cancelnvitation = (user) => {
    dispatch(cancelInvitionToOrganisationalUnit(props.organisationalUnit, user));

    setTimeout(() => {
      forceCloseContextualMenu('.manage-users-organisational-unit-container');
    }, 100);
  };

  return (
    <ContextualMenu
      id={props.selectedUser.id}
      options={[
        {
          title: APP.LANGUAGE.OrganisationalUnitUserActionMenu.ViewDetails,
          customAction: false,
          show: false,
        },
        {
          title: APP.LANGUAGE.OrganisationalUnitUserActionMenu.ManageRoles,
          customAction: false,
          show: !props.selectedUser.isEmailOnlyUser,
          action: () => clickManageRoles(props.selectedUser.id),
        },
        {
          title: APP.LANGUAGE.OrganisationalUnitUserActionMenu.ResendInvite,
          customAction: false,
          show: props.selectedUser.isEmailOnlyUser,
          action: () => resendInvitation(props.selectedUser),
        },
        {
          title: APP.LANGUAGE.OrganisationalUnitUserActionMenu.CancelInvite,
          customAction: false,
          show: props.selectedUser.isEmailOnlyUser,
          action: () => cancelnvitation(props.selectedUser),
        },
      ]}
    />
  );
}

export default OrganisationalUnitUserActionsMenu;
